import React from 'react';
import styled from 'styled-components';
import { breakpoints, spaces } from '@99designs/emu/settings';
import { IconX1 } from '@99designs/icons';
import { OnWhiteIconButton } from '@99designs/spa-common';

const SidebarHeaderWrapper = styled.div`
    @media (min-width: ${breakpoints.normal[0]}px) and (max-width: ${breakpoints.normal[1]}px),
        (min-width: ${breakpoints.large[0]}px) {
        min-height: 50px; /* Magic number for minimum header height */
    }
`;

const SidebarHeaderCloseButton = styled.div`
    display: none;
    position: absolute;
    z-index: 3;
    top: ${spaces['1bu']};
    right: ${spaces['2bu']};
    margin-top: -2px; /* magic number, alignment tuning. */
    line-height: 1;

    @media (min-width: ${breakpoints.normal[0]}px) and (max-width: ${breakpoints.normal[1]}px),
        (min-width: ${breakpoints.large[0]}px) {
        display: block;
    }
`;

interface SidebarHeaderProps {
    closeOverlayHandler: () => void;
    children?: React.ReactNode;
    onClick?: () => void;
}

function SidebarHeader({ closeOverlayHandler, children, onClick }: SidebarHeaderProps) {
    return (
        <SidebarHeaderWrapper data-testid="sidebar-header" onClick={onClick}>
            <SidebarHeaderCloseButton data-testid="close-overlay-button">
                <OnWhiteIconButton aria-label="Close" onClick={closeOverlayHandler}>
                    <IconX1 />
                </OnWhiteIconButton>
            </SidebarHeaderCloseButton>
            {children}
        </SidebarHeaderWrapper>
    );
}

export default SidebarHeader;
